import debounce from 'lodash.debounce';
import { useEffect } from 'react';
const getElementTopOffset = (element) => {
    let offsetTop = 0;
    while (element instanceof HTMLElement) {
        offsetTop += element.offsetTop - element.scrollTop + element.clientTop;
        element = element.offsetParent;
    }
    return offsetTop;
};
const updatePopoverPosition = ({ ref, triggerRef, alignment, containerRef }) => {
    const popover = ref.current;
    const trigger = triggerRef.current;
    const parent = containerRef.current;
    if (!popover || !trigger || !parent)
        return;
    /** @pM the page margin value. due to a chrome bug we cannot access the css variable from the browser here */
    let pM = 16;
    if (window.innerWidth > 375)
        pM = 28;
    if (window.innerWidth > 768)
        pM = 40;
    if (window.innerWidth > 1024)
        pM = 60;
    if (window.innerWidth > 1440)
        pM = 96;
    popover.style.left = '';
    popover.style.width = '';
    popover.style.right = '';
    const parentRect = parent.getBoundingClientRect();
    const triggerRect = trigger.getBoundingClientRect();
    const popoverRect = popover.getBoundingClientRect();
    const windowInnerWidth = window.innerWidth;
    let leftPosition = triggerRect.left;
    let rightPosition = windowInnerWidth - triggerRect.right;
    const popoverTop = getElementTopOffset(parent) + parentRect.height + 20;
    popover.style.top = `${popoverTop}px`;
    if (windowInnerWidth < 768) {
        popover.style.left = `${pM}px`;
        popover.style.right = `${pM}px`;
        return;
    }
    if (alignment === 'left') {
        leftPosition = triggerRect.left;
        if (leftPosition + popoverRect.width > windowInnerWidth - pM) {
            leftPosition = windowInnerWidth - popoverRect.width - pM;
        }
        if (leftPosition < pM) {
            leftPosition = pM;
        }
        popover.style.left = `${leftPosition}px`;
    }
    else if (alignment === 'right') {
        rightPosition = windowInnerWidth - triggerRect.right;
        if (rightPosition + popoverRect.width > windowInnerWidth - pM) {
            rightPosition = windowInnerWidth - popoverRect.width - pM;
        }
        if (rightPosition < pM) {
            rightPosition = pM;
        }
        popover.style.right = `${rightPosition}px`;
    }
    else {
        // Centered alignment
        let leftPosForCenteredPopover = triggerRect.left + triggerRect.width / 2 - popoverRect.width / 2;
        if (leftPosForCenteredPopover + popoverRect.width > windowInnerWidth - pM) {
            leftPosForCenteredPopover = windowInnerWidth - popoverRect.width - pM;
        }
        if (leftPosForCenteredPopover < pM) {
            leftPosForCenteredPopover = pM;
        }
        popover.style.left = `${leftPosForCenteredPopover}px`;
    }
};
export const usePopoverPosition = ({ ref, triggerRef, alignment, open, containerRef }) => {
    useEffect(() => {
        document.fonts.onloadingdone = () => {
            updatePopoverPosition({ ref, triggerRef, alignment, containerRef });
        };
    }, []);
    useEffect(() => {
        const debouncedUpdatePopoverPosition = debounce(updatePopoverPosition, 80);
        updatePopoverPosition({ triggerRef, alignment, ref, containerRef });
        const handleResize = () => {
            debouncedUpdatePopoverPosition({
                ref,
                triggerRef,
                alignment,
                containerRef
            });
        };
        window.addEventListener('resize', handleResize, { passive: true });
        return () => {
            window.removeEventListener('resize', handleResize);
            debouncedUpdatePopoverPosition.cancel();
        };
    }, [ref, alignment, open]);
};
//# sourceMappingURL=use-popover-position.js.map